import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

import { PackageFeatureInfoHolder } from "app/components/PackageSwitcher/components/PackageFeatureInfo/PackageFeatureInfo.styled";
import { PackageSwitcherContent } from "app/components/PackageSwitcher/components/PackageSwitcher/PackageSwitcher.styled";
import {
    SummaryHolder,
    SummaryItem,
    SummaryItemFlexColumn,
} from "app/components/PackageSwitcher/components/SummarySwitchCard/SummarySwitchCard.styled";

import { PackageFeatureInfoSkeleton } from "./PackageFeatureInfoSkeleton/PackageFeatureInfoSkeleton";

export const LoadingContent = () => {
    const { translate } = useTranslate();
    return (
        <PackageSwitcherContent>
            <PackageFeatureInfoHolder>
                <PackageFeatureInfoSkeleton />
            </PackageFeatureInfoHolder>
            <SummaryHolder>
                <Text
                    fontVariant="captionTitle"
                    color={colorsPalettes.carbon[300]}
                >
                    {translate("buyer_journey.switch_package.summary.title")}
                </Text>
                <SummaryItemFlexColumn>
                    <SummaryItem>
                        <PixelPlaceholderLoader
                            width={208}
                            height={20}
                        />
                        <PixelPlaceholderLoader
                            width={50}
                            height={20}
                        />
                    </SummaryItem>
                    <SummaryItem>
                        <PixelPlaceholderLoader
                            width={126}
                            height={20}
                        />
                        <PixelPlaceholderLoader
                            width={50}
                            height={20}
                        />
                    </SummaryItem>
                    <SummaryItem>
                        <PixelPlaceholderLoader
                            width={126}
                            height={20}
                        />
                        <PixelPlaceholderLoader
                            width={151}
                            height={20}
                        />
                    </SummaryItem>
                </SummaryItemFlexColumn>
            </SummaryHolder>
            <PixelPlaceholderLoader
                width={151}
                height={20}
            />
        </PackageSwitcherContent>
    );
};
